<template>
  <div v-if="items.length > 0" class="dropdown">
    <button
      v-if="variant == 'standard'"
      id="dropdownMenuButton"
      aria-expanded="false"
      aria-haspopup="true"
      class="btn border-color--primary-1 dropdown-toggle dropdown-size"
      data-toggle="dropdown"
      type="button"
    >
      <em v-if="icon" :key="icon" class="mr-2" :class="icon" />
      {{ title }}
    </button>
    <button
      v-else-if="variant == 'rounded-dark'"
      aria-expanded="false"
      aria-haspopup="true"
      class="btn border-none px-4 bg-secondary-16 text-white variant-rounded-dark rounded-pill"
      data-toggle="dropdown"
      type="button"
    >
      <em v-if="icon" :key="icon" class="mr-2" :class="icon" />
      {{ title }}
    </button>
    <div
      aria-labelledby="dropdownMenuButton"
      class="dropdown-menu dropdown-menu-right"
    >
      <div v-for="item in visibleItems" :key="item.label">
        <div
          class="dropdown-item py-2"
          :class="`${item.border && `border-${item.border}`} ${item.class}`"
          @click="eventHandler(item.click)"
        >
          <em
            v-if="item.icon"
            :key="item.icon + item.label"
            class="mr-2"
            :class="item.icon"
          />
          {{ item.label }}
        </div>

        <div
          v-for="child in item.children"
          :key="child.label"
          class="dropdown-item py-2 pl-5"
          :class="`${child.border && `border-${child.border}`} ${child.class}`"
          @click="eventHandler(child.click)"
        >
          <em
            v-if="child.icon"
            :key="child.icon + child.label"
            class="mr-2"
            :class="child.icon"
          />
          {{ child.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DropDown',
  props: {
    title: {
      type: String,
      default: () => 'Acciones',
    },
    icon: {
      type: String,
      default: () => null,
    },
    items: {
      type: Array,
      default: () => [],
    },
    dataItem: {
      type: [Number, Object],
      default: () => null,
    },
    variant: {
      type: String,
      default: () => 'standard',
    },
  },
  computed: {
    visibleItems() {
      const key = this.dataItem;

      return this.items.filter(function(item) {
        if (typeof item.visible === 'function') return item.visible(key);
        else return item.visible != false;
      });
    },
  },
  methods: {
    eventHandler(method) {
      if (method) {
        method(this.dataItem);
      }
    },
  },
};
</script>

<style scoped>
.btn:focus {
  box-shadow: none;
}

.variant-rounded-dark:after {
  font-family: 'Font Awesome 5 Free';
  color: #3f5b61;
  font-size: 22px;
  padding-left: 10px;
}

.variant-rounded-dark[aria-expanded='true']:after {
  content: '\f139' !important;
}

.variant-rounded-dark[aria-expanded='false']:after {
  content: '\f13a' !important;
}

.dropdown-item {
  cursor: pointer;
}

.dropdown-size {
  padding-left: 16px !important;
  padding-right: 16px !important;
  padding-top: 3px !important;
  padding-bottom: 3px !important;
}
</style>
